// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js??ref--5-1!./video-js.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("1384287e", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/video.js/dist/video-js.css
// module id = 593
// module chunks = 8